export default __webpack_public_path__ + "static/media/Montserrat-Medium.561e37f4.woff";